(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paid-landing-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paid-product-carousel')) {
    customElements.define('paid-product-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.paid-products__track');
        this.controls = this.querySelector('.paid-products__controls');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.addEventListener('click', event => {
          const swatch = event.target.closest('[data-paid-variant-url]');
          if (!swatch) return;
          const card = swatch.closest('.product-card');
          card.querySelectorAll('.product-card__link, .product-card__image-link').forEach(link => {
            link.setAttribute('href', swatch.dataset.paidVariantUrl);
          });
          card.querySelectorAll('[data-product-link]').forEach(button => {
            button.dataset.productLink = swatch.dataset.paidVariantUrl;
          });
        }, options);
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
      }
      disconnectedCallback() {
        this.abort.abort();
        this.resize.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
